export const TicketsHome = ({props})=>{
    return (
        <>
        Hello Tickets
        </>
    )
} 